import { SharingRecordFilterInput, User } from "../../../Utilities";

export const viewerSharingRecordFilter: SharingRecordFilterInput = {
	or: [
		{
			isPublicEQ: true,
		},
		{
			sharedUsers: [{ isCurrentEQ: true }],
		},
	],
};

export function getUsersSharingRecordFilter(userIDs: User["id"][]): SharingRecordFilterInput {
	return {
		or: [
			{
				isPublicEQ: true,
			},
			{
				sharedUsers: [{ idIn: userIDs }],
			},
		],
	};
}
